//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'List',
  props: {
    shadow: { type: Boolean, default: true },
    isEmpty: { type: Boolean, default: false },
    title: { type: String, default: '' },
    titleIcon: { type: String, default: '' },
    url: { type: String, default: '' },
  },
  methods: {
    gotoAll() {
      if (this.url) this.$router.push(this.url);
    },
  },
};
